import { render, staticRenderFns } from "./AskQuestionWidget.vue?vue&type=template&id=5a8192b6&scoped=true"
import script from "./AskQuestionWidget.vue?vue&type=script&lang=js"
export * from "./AskQuestionWidget.vue?vue&type=script&lang=js"
import style0 from "./AskQuestionWidget.vue?vue&type=style&index=0&id=5a8192b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8192b6",
  null
  
)

export default component.exports